import React from "react";
import { css } from "@emotion/react";
import Image from "next/image";
import Link from "next/link";
import { mq } from "@/constants/breakpoints";

// import { trustpilotHeightCSS } from "@/components/About/AwardSection";

import g2AwardSpring2023 from "../../../public/images/homepage/g2SetupBadge.svg";
import g2AwardSummer2023 from "../../../public/images/homepage/g2PerformerBadge.svg";
import g2AwardFall2023 from "../../../public/images/homepage/g2UsabilityBadge.svg";
import { H4, H7 } from "../Typography";
// import Script from "next/script";

const g2ScheduleGeneratorTrustBadgeCss = css`
  width: auto;
  ${mq["xs"]} {
    height: 50px;
  }
  ${mq["sm"]} {
    height: 41.48px;
  }
  ${mq["md"]} {
    width: 62px;
    height: 80px;
  }
  ${mq["lg"]} {
    height: 43.32px;
  }
`;

const ScheduleGeneratorTrustBadges: React.FC = () => {
  // const ref = useRef(null);

  // useEffect(() => {
  //   if ((window as any).Trustpilot) {
  //     (window as any).Trustpilot.loadFromElement(ref.current, true);
  //   }
  // }, []);

  return (
    <>
      {/* <Script
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        strategy="lazyOnload"
      /> */}
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 50px;
          background: linear-gradient(
            103.92deg,
            rgba(255, 255, 255, 0.1) -0.74%,
            rgba(190, 220, 255, 0.1) 99.87%
          );
          border-radius: 15px;
          padding: 10px 30px;
          a {
            display: inline-block;
            line-height: 0;
          }
          ${mq["xs"]} {
            width: 100%;
            justify-content: center;
            padding: 18px 30px;
          }
        `}
      >
        <div
          css={css`
            display: flex;

            justify-content: center;
            align-items: center;
            gap: 9px;
            ${mq["sm"]} {
              gap: 20px;
            }
            ${mq["xs"]} {
              gap: 26px;
            }
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
            `}
          >
            <Link
              href="https://www.g2.com/products/jersey-watch/reviews?utm_source=rewards-badge"
              target="_blank"
              rel="noopener"
            >
              <Image
                src={g2AwardSpring2023}
                alt={`G2 Award Fall 2024 Badge - ${process.env.g2Count}+ reviews Easiest Setup Sports Scheduling Software Solution`}
                css={g2ScheduleGeneratorTrustBadgeCss}
                height={50}
              />
            </Link>
            <Link
              href="https://www.g2.com/products/jersey-watch/reviews?utm_source=rewards-badge"
              target="_blank"
              rel="noopener"
            >
              <Image
                src={g2AwardSummer2023}
                alt={`G2 Award Fall 2024 Badge - ${process.env.g2Count}+ reviews High Performer Sports Scheduling Software Solution`}
                css={g2ScheduleGeneratorTrustBadgeCss}
              />
            </Link>
            <Link
              href="https://www.g2.com/products/jersey-watch/reviews?utm_source=rewards-badge"
              target="_blank"
              rel="noopener"
            >
              <Image
                src={g2AwardFall2023}
                alt={`G2 Award Fall 2024 Badge - ${process.env.g2Count}+ reviews Best Usability Sports Scheduling Software Solution`}
                css={g2ScheduleGeneratorTrustBadgeCss}
              />
            </Link>
          </div>
          <div
            css={css`
              display: flex;
              gap: 4px;
              align-items: baseline;
              ${mq["xs"]} {
                flex-direction: column;
                align-items: start;
                gap: 3px;
              }
              color: white;
            `}
          >
            <H4
              css={css`
                font-size: 18px;
                font-weight: 400;
                line-height: 20.8px;
              `}
            >
              {process.env.g2Count}+
            </H4>
            <H7
              css={css`
                font-size: 12px;
                font-weight: 350;
                line-height: 14.4px;
              `}
            >
              reviews
            </H7>
          </div>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 9px;
            ${mq["sm"]} {
              flex-direction: row;
              gap: 20px;
            }
            ${mq["xs"]} {
              display: none;
            }
            ${mq["sm"]} {
              display: flex;
            }
          `}
        >
          <Link
            href="https://www.capterra.com/p/178257/Jersey-Watch/reviews?utm_source=vendor&utm_medium=badge&utm_campaign=capterra_reviews_badge"
            target="_blank"
            rel="noopener"
          >
            <img
              src="https://assets.capterra.com/badge/1dde7f6139f1c168c795e5395bc8f578.svg?v=2124160&p=178257"
              alt="Capterra Review 4.9 Rating 155+ reviews"
              css={css`
                width: auto;
                ${mq["xs"]} {
                  height: 41.48px;
                }
                ${mq["md"]} {
                  height: 43px;
                }
                ${mq["lg"]} {
                  height: 43.32px;
                }
              `}
            />
          </Link>
          <div
            css={css`
              display: flex;
              gap: 4px;
              align-items: baseline;
              ${mq["sm"]} {
                flex-direction: column;
                align-items: start;
                gap: 3px;
              }
              color: white;
            `}
          >
            <H4
              css={css`
                font-size: 18px;
                font-weight: 400;
                line-height: 20.8px;
              `}
            >
              {process.env.capterraCount || 100}+
            </H4>
            <H7
              css={css`
                font-size: 12px;
                font-weight: 350;
                line-height: 14.4px;
              `}
            >
              reviews
            </H7>
          </div>
        </div>
        {/* <div
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5c0aad580b068b0001e14acb"
          data-style-width="100%"
          data-theme="light"
          css={css`
            ${trustpilotHeightCSS}
            ${mq["sm"]} {
              padding: 14px 0;
            }
            ${mq["md"]} {
              padding: 14px 0;
            }
            background: rgba(255, 255, 255, 0.5);
            border-radius: 5px;
          `}
        >
          <Link
            href="https://www.trustpilot.com/review/jerseywatch.com"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </Link>
        </div> */}
      </div>
    </>
  );
};

interface TrustpilotBadgeProps {}

export const TrustpilotBadge = ({}: TrustpilotBadgeProps) => {
  return (
    <svg
      width="273"
      height="31"
      viewBox="0 0 273 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_133_7451)">
        <rect
          opacity="0.1"
          x="-54"
          y="-11"
          width="394"
          height="50"
          rx="7.16825"
          fill="#00B67A"
        />
        <path
          d="M127.345 5.00549H106.07V26.2807H127.345V5.00549Z"
          fill="#00B67A"
        />
        <path
          d="M150.177 5.00549H128.902V26.2807H150.177V5.00549Z"
          fill="#00B67A"
        />
        <path
          d="M173.218 5.00549H151.943V26.2807H173.218V5.00549Z"
          fill="#00B67A"
        />
        <path
          d="M196.045 5.00549H174.77V26.2807H196.045V5.00549Z"
          fill="#00B67A"
        />
        <path
          d="M219.091 5.00549H197.816V26.2807H219.091V5.00549Z"
          fill="#DCDCE6"
        />
        <mask
          id="mask0_133_7451"
          style={{ maskType: "alpha" }} // Changed to object format
          maskUnits="userSpaceOnUse"
          x="197"
          y="5"
          width="23"
          height="22"
        >
          <path d="M219.086 5H197.811V26.2752H219.086V5Z" fill="#DCDCE6" />
        </mask>
        <g mask="url(#mask0_133_7451)">
          <path
            d="M196.661 4.64258H219.022V28.3187H196.661V4.64258Z"
            fill="#00B67A"
          />
        </g>
        <path
          d="M116.482 19.201L119.807 18.3145L121.136 22.5252L116.482 19.201ZM124.017 13.8822H118.255L116.482 8.56335L114.709 13.8822H109.169L113.823 17.2064L112.05 22.5252L116.704 19.201L119.585 17.2064L124.017 13.8822Z"
          fill="white"
        />
        <path
          d="M139.54 19.201L142.865 18.3145L144.194 22.5252L139.54 19.201ZM146.854 13.8822H141.092L139.319 8.56335L137.546 13.8822H131.784L136.438 17.2064L134.665 22.5252L139.319 19.201L142.2 17.2064L146.854 13.8822Z"
          fill="white"
        />
        <path
          d="M162.581 19.201L165.906 18.3145L167.235 22.5252L162.581 19.201ZM169.895 13.8822H164.133L162.36 8.56335L160.587 13.8822H154.825L159.479 17.2064L157.927 22.5252L162.581 19.201L165.462 17.2064L169.895 13.8822Z"
          fill="white"
        />
        <path
          d="M185.401 19.201L188.725 18.3145L190.055 22.5252L185.401 19.201ZM192.936 13.8822H187.174L185.401 8.56335L183.628 13.8822H177.866L182.52 17.2064L180.747 22.5252L185.401 19.201L188.282 17.2064L192.936 13.8822Z"
          fill="white"
        />
        <path
          d="M208.458 19.201L211.782 18.3145L213.112 22.5252L208.458 19.201ZM215.771 13.8822H210.009L208.236 8.56335L206.685 13.8822H200.923L205.577 17.2064L203.804 22.5252L208.458 19.201L211.339 17.2064L215.771 13.8822Z"
          fill="white"
        />
        <path
          d="M28.7441 12.919H21.5175L19.365 6L17.0586 12.919H9.98584L15.6748 17.0704L13.5222 23.9895L19.365 19.6843L25.0539 23.9895L22.9013 17.0704L28.7441 12.919Z"
          fill="#00B67A"
        />
        <path
          d="M23.3619 18.6021L22.9006 17.0645L19.3643 19.6784L23.3619 18.6021Z"
          fill="#005128"
        />
        <path
          d="M31.1026 13.7018V12.0769H38.7584V13.7018H35.9046V21.3986H33.9565V13.7018H31.1026ZM39.2568 21.3986V14.4073H41.1366V15.6271H41.2094C41.3369 15.1932 41.5508 14.8655 41.8512 14.644C42.1516 14.4194 42.4976 14.3072 42.889 14.3072C42.9861 14.3072 43.0908 14.3132 43.2031 14.3254C43.3153 14.3375 43.4139 14.3542 43.4989 14.3754V16.0959C43.4079 16.0686 43.2819 16.0444 43.1211 16.0231C42.9603 16.0019 42.8131 15.9913 42.6796 15.9913C42.3944 15.9913 42.1395 16.0535 41.9149 16.1779C41.6934 16.2992 41.5174 16.4692 41.387 16.6877C41.2595 16.9061 41.1958 17.158 41.1958 17.4432V21.3986H39.2568ZM48.9847 18.4218V14.4073H50.9237V21.3986H49.0621V20.1287H48.9893C48.8315 20.5383 48.569 20.8675 48.2018 21.1164C47.8377 21.3652 47.3932 21.4896 46.8682 21.4896C46.4009 21.4896 45.9898 21.3834 45.6347 21.171C45.2797 20.9586 45.0021 20.6566 44.8018 20.2652C44.6046 19.8738 44.5044 19.405 44.5014 18.8588V14.4073H46.4404V18.5128C46.4434 18.9255 46.5542 19.2517 46.7726 19.4914C46.9911 19.7312 47.2839 19.851 47.6511 19.851C47.8848 19.851 48.1032 19.7979 48.3065 19.6917C48.5098 19.5825 48.6737 19.4216 48.7981 19.2092C48.9256 18.9968 48.9878 18.7344 48.9847 18.4218ZM58.2916 16.4009L56.5165 16.5101C56.4861 16.3584 56.4209 16.2219 56.3208 16.1005C56.2206 15.9761 56.0886 15.8775 55.9248 15.8046C55.7639 15.7288 55.5713 15.6909 55.3467 15.6909C55.0463 15.6909 54.7929 15.7546 54.5866 15.882C54.3803 16.0064 54.2771 16.1733 54.2771 16.3827C54.2771 16.5496 54.3439 16.6907 54.4774 16.806C54.6109 16.9213 54.84 17.0139 55.1647 17.0836L56.43 17.3385C57.1097 17.4781 57.6165 17.7027 57.9502 18.0122C58.284 18.3217 58.4509 18.7283 58.4509 19.232C58.4509 19.6902 58.3159 20.0923 58.0458 20.4382C57.7788 20.7841 57.4116 21.0542 56.9443 21.2484C56.4801 21.4395 55.9445 21.5351 55.3376 21.5351C54.4121 21.5351 53.6748 21.3424 53.1255 20.9571C52.5793 20.5687 52.2592 20.0407 52.1652 19.3731L54.0723 19.273C54.1299 19.5552 54.2695 19.7706 54.491 19.9193C54.7125 20.0649 54.9962 20.1378 55.3422 20.1378C55.682 20.1378 55.9551 20.0725 56.1615 19.942C56.3708 19.8085 56.477 19.6371 56.4801 19.4277C56.477 19.2517 56.4027 19.1076 56.257 18.9953C56.1114 18.88 55.8868 18.792 55.5834 18.7313L54.3727 18.4901C53.6899 18.3535 53.1817 18.1169 52.8479 17.78C52.5171 17.4432 52.3518 17.0139 52.3518 16.4919C52.3518 16.0428 52.4731 15.656 52.7159 15.3313C52.9617 15.0066 53.3061 14.7563 53.7491 14.5803C54.1952 14.4043 54.7171 14.3163 55.3149 14.3163C56.1979 14.3163 56.8927 14.5029 57.3995 14.8761C57.9093 15.2493 58.2066 15.7576 58.2916 16.4009ZM63.3905 14.4073V15.8638H59.1803V14.4073H63.3905ZM60.1361 12.7323H62.0751V19.2502C62.0751 19.4292 62.1024 19.5688 62.1571 19.669C62.2117 19.7661 62.2875 19.8343 62.3846 19.8738C62.4848 19.9132 62.6001 19.9329 62.7306 19.9329C62.8216 19.9329 62.9126 19.9254 63.0036 19.9102C63.0947 19.892 63.1645 19.8783 63.213 19.8692L63.518 21.3121C63.4209 21.3424 63.2843 21.3773 63.1083 21.4168C62.9323 21.4592 62.7184 21.485 62.4666 21.4941C61.9993 21.5123 61.5896 21.4501 61.2376 21.3075C60.8887 21.1649 60.6171 20.9434 60.4229 20.643C60.2287 20.3426 60.1331 19.9633 60.1361 19.5051V12.7323ZM64.6536 24.0203V14.4073H66.5653V15.5816H66.6518C66.7367 15.3935 66.8596 15.2023 67.0204 15.0081C67.1843 14.8109 67.3967 14.647 67.6577 14.5165C67.9217 14.383 68.2494 14.3163 68.6408 14.3163C69.1506 14.3163 69.6209 14.4498 70.0518 14.7168C70.4827 14.9808 70.8271 15.3798 71.085 15.9139C71.3429 16.4449 71.4719 17.111 71.4719 17.912C71.4719 18.6919 71.346 19.3503 71.0941 19.8874C70.8453 20.4215 70.5054 20.8266 70.0746 21.1027C69.6467 21.3758 69.1673 21.5123 68.6363 21.5123C68.26 21.5123 67.9399 21.4501 67.6759 21.3257C67.4149 21.2013 67.201 21.0451 67.0341 20.8569C66.8672 20.6658 66.7398 20.4731 66.6518 20.2789H66.5926V24.0203H64.6536ZM66.5516 17.9029C66.5516 18.3186 66.6093 18.6813 66.7246 18.9908C66.8399 19.3003 67.0068 19.5415 67.2253 19.7145C67.4437 19.8844 67.7092 19.9694 68.0218 19.9694C68.3374 19.9694 68.6044 19.8829 68.8229 19.7099C69.0413 19.5339 69.2067 19.2912 69.319 18.9817C69.4343 18.6691 69.492 18.3095 69.492 17.9029C69.492 17.4994 69.4358 17.1443 69.3235 16.8379C69.2113 16.5314 69.0459 16.2917 68.8274 16.1187C68.6089 15.9457 68.3404 15.8593 68.0218 15.8593C67.7062 15.8593 67.4392 15.9427 67.2207 16.1096C67.0053 16.2765 66.8399 16.5132 66.7246 16.8196C66.6093 17.1261 66.5516 17.4872 66.5516 17.9029ZM72.7646 21.3986V14.4073H74.7035V21.3986H72.7646ZM73.7386 13.5061C73.4503 13.5061 73.203 13.4105 72.9967 13.2193C72.7934 13.0251 72.6917 12.793 72.6917 12.5229C72.6917 12.2559 72.7934 12.0268 72.9967 11.8356C73.203 11.6414 73.4503 11.5443 73.7386 11.5443C74.0269 11.5443 74.2727 11.6414 74.476 11.8356C74.6823 12.0268 74.7855 12.2559 74.7855 12.5229C74.7855 12.793 74.6823 13.0251 74.476 13.2193C74.2727 13.4105 74.0269 13.5061 73.7386 13.5061ZM78.1958 12.0769V21.3986H76.2568V12.0769H78.1958ZM82.9078 21.5351C82.2008 21.5351 81.5894 21.3849 81.0735 21.0845C80.5607 20.7811 80.1647 20.3593 79.8855 19.8192C79.6064 19.276 79.4668 18.6464 79.4668 17.9302C79.4668 17.2081 79.6064 16.5769 79.8855 16.0368C80.1647 15.4936 80.5607 15.0718 81.0735 14.7714C81.5894 14.468 82.2008 14.3163 82.9078 14.3163C83.6148 14.3163 84.2247 14.468 84.7375 14.7714C85.2534 15.0718 85.6509 15.4936 85.9301 16.0368C86.2092 16.5769 86.3488 17.2081 86.3488 17.9302C86.3488 18.6464 86.2092 19.276 85.9301 19.8192C85.6509 20.3593 85.2534 20.7811 84.7375 21.0845C84.2247 21.3849 83.6148 21.5351 82.9078 21.5351ZM82.9169 20.0331C83.2385 20.0331 83.5071 19.942 83.7225 19.76C83.938 19.5749 84.1003 19.323 84.2096 19.0044C84.3218 18.6858 84.378 18.3232 84.378 17.9166C84.378 17.51 84.3218 17.1474 84.2096 16.8288C84.1003 16.5101 83.938 16.2583 83.7225 16.0732C83.5071 15.8881 83.2385 15.7955 82.9169 15.7955C82.5922 15.7955 82.3191 15.8881 82.0976 16.0732C81.8791 16.2583 81.7138 16.5101 81.6015 16.8288C81.4923 17.1474 81.4376 17.51 81.4376 17.9166C81.4376 18.3232 81.4923 18.6858 81.6015 19.0044C81.7138 19.323 81.8791 19.5749 82.0976 19.76C82.3191 19.942 82.5922 20.0331 82.9169 20.0331ZM91.3283 14.4073V15.8638H87.118V14.4073H91.3283ZM88.0739 12.7323H90.0128V19.2502C90.0128 19.4292 90.0402 19.5688 90.0948 19.669C90.1494 19.7661 90.2253 19.8343 90.3224 19.8738C90.4225 19.9132 90.5378 19.9329 90.6683 19.9329C90.7593 19.9329 90.8503 19.9254 90.9414 19.9102C91.0324 19.892 91.1022 19.8783 91.1507 19.8692L91.4557 21.3121C91.3586 21.3424 91.2221 21.3773 91.0461 21.4168C90.8701 21.4592 90.6561 21.485 90.4043 21.4941C89.937 21.5123 89.5273 21.4501 89.1754 21.3075C88.8264 21.1649 88.5548 20.9434 88.3606 20.643C88.1664 20.3426 88.0708 19.9633 88.0739 19.5051V12.7323Z"
          fill="#191919"
        />
        <path
          d="M240.164 19.794V18.282H234.98C234.242 18.282 233.63 17.742 233.63 17.004C233.63 16.428 233.864 15.978 234.278 15.492L239.75 9.138C240.272 8.526 240.668 8.202 241.478 8.202C242.216 8.202 242.81 8.778 242.81 9.516V16.032H243.476C244.106 16.032 244.61 16.536 244.61 17.166C244.61 17.796 244.106 18.282 243.476 18.282H242.81V19.794C242.81 20.532 242.216 21.108 241.478 21.108C240.74 21.108 240.164 20.532 240.164 19.794ZM236.816 16.032H240.164V12.108L236.816 16.032ZM246.418 19.542C246.418 18.678 247.084 18.012 247.984 18.012C248.884 18.012 249.55 18.678 249.55 19.542V19.578C249.55 20.442 248.884 21.108 247.984 21.108C247.084 21.108 246.418 20.442 246.418 19.578V19.542ZM255.997 21.216C254.593 21.216 253.603 20.892 252.667 20.316C252.289 20.082 252.019 19.686 252.019 19.182C252.019 18.462 252.613 17.922 253.333 17.922C253.603 17.922 253.837 18.012 254.053 18.138C254.701 18.516 255.277 18.696 256.069 18.696C257.617 18.696 258.445 17.526 258.625 15.834C258.013 16.356 257.167 16.698 256.069 16.698C253.333 16.698 251.569 15.186 251.569 12.63V12.594C251.569 10.056 253.531 8.184 256.375 8.184C258.067 8.184 259.057 8.598 260.011 9.552C260.911 10.452 261.505 11.82 261.505 14.304V14.34C261.505 18.426 259.579 21.216 255.997 21.216ZM256.519 14.394C257.887 14.394 258.679 13.602 258.679 12.522V12.486C258.679 11.37 257.851 10.56 256.465 10.56C255.097 10.56 254.323 11.352 254.323 12.468V12.504C254.323 13.62 255.151 14.394 256.519 14.394Z"
          fill="#243B4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_133_7451">
          <rect width="273" height="31" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ScheduleGeneratorTrustBadges;
